import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import styles from "../css/shared.module.css";

const MainLayout = ({ children }) => {
  return (
    <div className={styles.appContainer}>
      <Header />
      <main className={styles.mainContent}>{children}</main>
      <Footer />
    </div>
  );
};

export default MainLayout;
